<template>
  <div class="dataloggerManage">
    <div class="section">
      <div class="search">
        <div class="searchLeft"></div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="adminSearch">
            <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
              @keyup.enter.native="getDeviceList(true)" :placeholder="this.$t('project.placeholder')" clearable>
            </el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="getDeviceList(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <!-- <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span> -->
          </div>
        </div>
      </div>
      <el-table :data="deviceList" border stripe height="100%"  :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="loadingDevice"
        element-loading-spinner="el-icon-loading" class="tablemain tableloding">
        <el-table-column min-width="140px;" fixed  :show-overflow-tooltip="true"
          label="SN">
          <template slot-scope="scope">
            <span :title="scope.row.sn">{{scope.row.sn }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('device.device_name')">
          <template slot-scope="scope">
            <span :title="scope.row.devalias">{{scope.row.devalias ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column width="160px;" :show-overflow-tooltip="true"
          :label="this.$t('device.User_belong')">
          <template slot-scope="scope">
            <span :class="{'redirect':scope.row.usr}" @click="enterAccount(scope.row)" :title="scope.row.usr">{{scope.row.usr ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column width="100px;" :show-overflow-tooltip="true"
          :label="$t('device.device_status')">
          <template slot-scope="scope">
            <div :class="`background-${$filter.deviceStatus[scope.row.status].name}`" style="border-radius: 5px;">
              <span :class="`radius-${$filter.deviceStatus[scope.row.status].name}`" style="width: 8px;height: 8px;border-radius: 8px;display: inline-block;margin-right: 5px;"></span>
              <span v-if="scope.row.status !== undefined" :class="`color-${$filter.deviceStatus[scope.row.status].name}`">{{
              $filter.deviceStatus[scope.row.status].label||"--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="100px;" :show-overflow-tooltip="true"
          :label="this.$t('device.device_address')">
          <template slot-scope="scope">
            <span :title="scope.row.devaddr">{{scope.row.devaddr ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column width="140px;" :show-overflow-tooltip="true" :label="$t('device.device_type')">
          <template slot-scope="scope">
            <span v-if="scope.row.brand>=0&&scope.row.brand<=4" :title="$filter.deviceType[scope.row.brand].label">{{ $filter.deviceType[scope.row.brand].label }}</span>
            <span v-else :title="'--'">{{ '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100px;" :show-overflow-tooltip="true"
          :label="this.$t('device.device_code')">
          <template slot-scope="scope">
            <span :title="scope.row.devcode">{{scope.row.devcode ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120px;" fixed="right" :show-overflow-tooltip="true"
          label="PN">
          <template slot-scope="scope">
            <span :title="scope.row.pn">{{scope.row.pn ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" fixed="right" :show-overflow-tooltip="true"
          :label="this.$t('device.coll_alias')">
          <template slot-scope="scope">
            <span :title="scope.row.collalias">{{scope.row.collalias ||"--"}}</span>
          </template>
        </el-table-column>
        <!-- 能流加速重置次数 -->
        <el-table-column min-width="140px;" fixed="right" :show-overflow-tooltip="true"
          :label="this.$t('device.Operation')">
          <template slot-scope="scope">
            <el-button type="text" class="operation"
                :disabled="scope.row.usr ? false : true"
                :class="{ operation1: scope.row.usr == undefined }" :title="$t('datalogger.reset')"
                @click="resetFlow(scope.row)">
                <i class="iconfont icon-a-mingchengzhongzhiyangshidansexianxingtubiao1"></i>
              </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" background @size-change="getDeviceList(true)"
          @current-change="() => getDeviceList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 重置能流加速次数二次确认 -->
    <reset-dialog title="" :visible.sync="showResetDialog" :width="'450px'"
      :class="{ 'showDialog': showResetDialog, 'hideDialog': !showResetDialog }" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;">是否确认重置能流加速次数</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="confirmResetFlow">{{
            $t('account.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="showResetDialog = false">{{ $t('account.cancel') }}</button>
        </div>
      </div>
    </reset-dialog>
  </div>
</template>
<script>
import cookie from '../../../assets/js/cookie';
import resetDialog from "@/components/dialognew";

export default {
  components: {
    resetDialog,
  },
  data () {
    return {
      // 重置能流加速次数确认弹框
      showResetDialog: false,
      resetFlowItem: null,
      search: {
        search:"",
      },
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      loadingDevice: false,
      deviceList: [],
      // 搜索弹出
      showSearch: false,
    };
  },
  computed: {
    // 时区过滤
    filterTimeZone() {
      return (val) => (this.zoneList[val] ? this.zoneList[val].name : "--");
    },
  },
  watch: {
  },
  created () {
    this.getDeviceList()
  },
  methods: {
    // 重置能流加速次数
    resetFlow(item){
      // 打开二次确认弹框
      this.resetFlowItem = item;
      this.showResetDialog = true;
    },
    // 确认重置能流加速次数
    confirmResetFlow(){
      const item = this.resetFlowItem;
      this.showResetDialog = false;
      if (!item) return;
      let params={
        sn: item.sn,
        pn: item.pn,
        devcode: item.devcode,
        devaddr: item.devaddr,
      }
      this.$request.postDEVMicroservices("/rqc/api/auth/energyFlow/resetFetchCount",params).then(res=>{
        if (res.code==0) {
          this.$message.success(this.$t('datalogger.resetSuc'))
        }else{
          this.$message.error(res.message)
        }
      }).catch((err)=>{
        this.$message.error('请求失败,接口异常')
      })
    },
    // 设备列表数据
    getDeviceList(reset){
      this.loadingDevice=true
      if (reset) this.pagination.currentPage = 1;
      let params={
        page: this.pagination.currentPage-1,
        pagesize: this.pagination.pagesize,
        i18n: this.$lang.currentLang,
        devtype: "2304",
        search: this.search.search,
      }
      this.$request.get("adminQueryAllDevice",params).then(res=>{
        this.loadingDevice=false
        if (res.err==0) {
          this.deviceList=res.dat.device
          this.pagination.total=res.dat.total
        }else{
          this.deviceList = [];
          this.pagination.total = 0;
        }
      }).catch((err)=>{
        this.loadingDevice=false
        this.deviceList = [];
        this.pagination.total = 0;
      })
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.search = '';
      this.getDeviceList();
    },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
    // 跳转用户
    enterAccount (info) {
      if (info.usr) {
        this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }else{
        this.$message.error(this.$t("datalogger.title_usr"));
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .redirect {
    color: @primaryTextColor;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);
      .searchRight{
        display: flex;
        justify-content: flex-end;
        .adminSearch{
          border-left: 1px solid #7B8395 ;
          display: flex;
          justify-content: flex-start;
          .searchAll {
        /deep/.el-input__inner {
          width: 220px;
          padding-left: 10px;
        }
        }

        .search-device {
        display: inline-block;
        line-height: 48px;
        padding: 0 15px;
        width: 100%;
        font-size: 14px;
        background: #202D35;
        color: #33FFB6;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }

        .search-hide {
        display: inline-block;
        // position: absolute;
        // right: -58px;
        // line-height: 48px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        font-size: 14px;
        background: #202D35;
        color: #7B8395;
        border-left: 1px solid #7B8395;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }
        }
      }

      .statusName {
        padding: 0 16px;
        color: #ADB9C0;
        font-size: 12px;
        line-height: 48px;
        font-weight: 700;
      }

      .statusList {
        cursor: pointer;
        padding: 0 16px;
        color: #70818C;
        font-size: 14px;
        height: 48px;
        line-height: 48px;
      }

      .active {
        color: #00FEBB;
        border-bottom: 2px solid #00FEBB;
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      // 添加数采器
      .button-addscq {
        // width: 114px;
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;

        span {
          font-size: 14px;
        }

        i {
          margin-left: 10px;
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);
      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      // 表格右侧边线
      // /deep/.el-table--border::after, 
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        height: 41px;
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00FEBB;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7B8395;
  }

  .el-month-table td .cell:hover {
    color: #00FEBB;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00FEBB;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7B8395;
  }

  .el-year-table td .cell:hover {
    color: #00FEBB;
  }
}
.tablemain.el-table--border::after {
  display: none;
}

.dataloggerManage {
  .scqsbAlert {

    .el-table--border::after,
    .el-table--group::after {
      display: block;
      background-color: #A3A9B5;
    }

    // 弹窗表格右侧边线
    .el-table--border {
      border-right: 1px solid #A3A9B5;
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }

    // 加载数据时遮罩
    .el-loading-mask {
      background-color: transparent;
    }

    .el-loading-spinner i {
      color: @primaryTextColor;
    }
  }
}
</style>
